import KeywordTable from './KeywordTable';
import React, { Component } from 'react'
import { bool, number, arrayOf, shape, string } from 'prop-types';

import { shapeOfKeywordData } from './constant';
export default class index extends Component {
  static propTypes = {
    inpdf: bool,
    rowsPerPage: number,
    page: number,
    beginKeyword: number,
    isCustomReport: bool,
    isGrandTotalDisplay: bool,
    data: arrayOf(shapeOfKeywordData),
    tableSortSelector: shape({
      sortKey: string,
      sortType: string,
    }),
    itemIndex: number,
    isNewAdUsersSelected: bool,
  }
  
  render() {
    const { 
      inpdf, 
      rowsPerPage, 
      page, 
      beginKeyword, 
      isCustomReport,
      isGrandTotalDisplay,
      data,
      tableSortSelector,
      itemIndex,
      isNewAdUsersSelected,
      ...otherProps
    } = this.props;
    return (
      <KeywordTable
        inpdf={inpdf}
        isGrandTotalDisplay={isGrandTotalDisplay}
        data={data}
        rowsPerPage={rowsPerPage}
        page={page}
        beginKeyword={beginKeyword}
        isCustomReport={isCustomReport}
        tableSortSelector={tableSortSelector}
        itemIndex={itemIndex}
        isNewAdUsersSelected={isNewAdUsersSelected}
        {...otherProps}
      />
    )
  }
}
